var IconSize;
(function (IconSize) {
    IconSize["Small"] = "1.125rem";
    IconSize["Medium"] = "1.5rem";
    IconSize["Large"] = "2rem";
    IconSize["ExtraLarge"] = "3rem";
    IconSize["Hero"] = "4rem"; // 64px
})(IconSize || (IconSize = {}));
export default IconSize;
//# sourceMappingURL=IconSize.js.map